<lib-page-layout>
  <lib-title-navbar pageHeader [title]="content().title" [showBackArrow]="false" [showDots]="false"></lib-title-navbar>

  <div class="or-d-flex or-flex-col or-align-items-center or-justify-content-center or-h-100-pc or-px-32-px">
    <div
      class="connection-error-icon or-bg-focus or-d-flex or-align-items-center or-justify-content-center or-mb-24-px">
      <or-icon [name]="content().icon" size="xl" class="or-color-main-1" />
    </div>

    <div class="or-head-xl or-text-align-center or-mb-12-px">{{ content().title }}</div>

    <div class="or-text-md or-color-secondary-2 or-text-align-center">{{ content().message }}</div>
  </div>

  <lib-page-actions pageActions>
    <button class="button-primary-style or-h-48-px or-w-100-pc or-head-sm" (click)="retry()">Spróbuj ponownie</button>
  </lib-page-actions>

  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
